<template>
  <Layout>
    <div>Logs</div>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main.vue";

export default {
  components: {
    Layout,
  },
};
</script>

<style>
</style>